var AbstractWS = require("./AbstractWS");

function IssueWS(viewModel) {
  var self;

  // Predicate this Web Service handler on the Abstract class of a Web
  // Service handler. This establishes core functionality required of
  // these such handlers, which can be overwritten by methods below.
  AbstractWS.apply(this, arguments);

  self = this;
  self.method('POST');
  self.name = 'IssueWS';			// Convenience name for debugging


	/**
	 * Defines the string to request API services
	 *
	 * @method serviceURL
	 * @returns {String}
	 */
  self.serviceURL = ko.computed(function () {
    return '/qless/api/v1/employee/queue/' + self.parent.id + '/tickets/issue';
  });

  self.processData = function (data, avoidCallback) {
    AbstractWS.prototype.processData.call(self, data, avoidCallback);

    if (self.err) {
      self.triggerEarlyAppointmentConfirmation(self.err);
    }
  };

  /**
   * Handles the Employee summoning an Appointment before the Appointment's Start Time. 
   *
   * @param {Object} error object representing a Java Exception
   */
  self.triggerEarlyAppointmentConfirmation = function (error) {
    if (self.hasEarlyAppointmentError(error)) {
      var consumerSessionId = this.findEarlyAppointmentSessionId(error);
      if (consumerSessionId) {
        vm.earlyAppointmentConfirmationShow(consumerSessionId);
      }
    }
  };

  self.hasEarlyAppointmentError = function(error) {
    return (error.rootCauseType === this.EARLY_APPOINTMENT_TICKET_EXCEPTION)
  };

  return self;
};

IssueWS.prototype = Object.create(AbstractWS.prototype);
IssueWS.prototype.constructor = IssueWS;

IssueWS.prototype.EARLY_APPOINTMENT_TICKET_EXCEPTION = "EarlyAppointmentTicketException";

/**
 * Recurse into an Error to find the Session ID
 *
 * @param {object} Java Exception JSON (XML)
 */
IssueWS.prototype.findEarlyAppointmentSessionId = function(error) {
  if (error.type && error.type === this.EARLY_APPOINTMENT_TICKET_EXCEPTION) {
    return error.text;
  } 
  else if (error.cause) {
    return this.findEarlyAppointmentSessionId(error.cause);
  }
  else {
    return null;
  }
};

module.exports = IssueWS;
